import { TableCell } from '@material-ui/core';
import { Icon, iconType } from '@sensenet/icons-react';
import React, { useState } from 'react';
export const VirtualDisplayNameCell = props => {
  const [icon] = useState(props.rowData.Icon && props.icons && props.icons[props.rowData.Icon.toLowerCase()]);
  const [type] = useState(props.rowData.Icon === 'word' || props.rowData.Icon === 'excel' || props.rowData.Icon === 'acrobat' || props.rowData.Icon === 'powerpoint' ? iconType.flaticon : iconType.materialui);
  return /*#__PURE__*/React.createElement(TableCell, {
    style: {
      height: '57px',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      padding: 0
    },
    component: "div",
    className: "display-name"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, icon ? /*#__PURE__*/React.createElement(Icon, {
    type: type,
    iconName: icon,
    style: {
      marginRight: '.5em'
    }
  }) : null, /*#__PURE__*/React.createElement("div", null, props.rowData.DisplayName || props.rowData.Name)));
};
//# sourceMappingURL=VirtualDisplayNameCell.js.map